var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 20,
    viewBox: "0 0 56 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4248 9.01118C0.722287 9.01118 0.152784 9.58069 0.152784 10.2832C0.152784 10.9857 0.722287 11.5552 1.4248 11.5552L1.4248 9.01118ZM54.9011 11.1827C55.3979 10.6859 55.3979 9.88051 54.9011 9.38375L46.806 1.28866C46.3093 0.791907 45.5039 0.791907 45.0071 1.28866C44.5104 1.78542 44.5104 2.59082 45.0071 3.08757L52.2028 10.2832L45.0071 17.4788C44.5104 17.9756 44.5104 18.781 45.0071 19.2778C45.5039 19.7745 46.3093 19.7745 46.806 19.2778L54.9011 11.1827ZM1.4248 11.5552L54.0017 11.5552L54.0017 9.01119L1.4248 9.01118L1.4248 11.5552Z",
    fill: "#FF7676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/Arrow 1.6896f383de2101c7b372a9e66ca81471.svg";
export { ForwardRef as ReactComponent };